import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { logChanges } from 'src/app/util/interfaces/log.interface';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CmdbRegisterPageInconsistenciesService {
	private readonly http = inject(HttpClient);
	private readonly AuthLoginService = inject(AuthLoginService);
	private readonly profileService = inject(ProfileService);

	constructor() {}

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	getAllInconsistenciesTypes(): Observable<any> {
		const url = environment.baseApiUrl + 'myasset/inconsistenciesTypes';
		return this.http.get<any>(url, { headers: this.headers });
	}

	getInconsistencies(idCMDB: string): Observable<any> {
		const url = environment.baseApiUrl + 'inconsistency/cmdb/{idCMDB}';
		const getInconsistenciesUrl = url.replace('{idCMDB}', idCMDB);
		return this.http.get<any>(getInconsistenciesUrl, { headers: this.headers });
	}

	getExceptionsInconsistencies(idCi: string): Observable<any> {
		const defaultCustomer = this.profileService.userData().idCustomer;
		const url = environment.baseApiUrl + 'inconsistency/exception';

		return this.http.get<any>(url, {
			headers: this.headers,
			params: {
				cmdb_id: idCi,
				customer: defaultCustomer,
			},
		});
	}

	getInconsistenciesExceptionLogs(idCi: string): Observable<logChanges[]> {
		const url = environment.baseApiUrl + 'inconsistency/exclusion/logs';

		return this.http.get<logChanges[]>(url, {
			headers: this.headers,
			params: {
				cmdb_id: idCi,
			},
		});
	}

	saveExceptionsInconsistencies(
		idCi: string,
		selectedInconsistenciesTypes: any[],
		exceptionInconsistencyDate: string,
		notes: string = ''
	): Observable<any> {
		const url = environment.baseApiUrl + 'inconsistency/createException';
		// Transforma o array de IDs em um objeto onde cada ID é uma chave com a data como valor
		const inconsistenciesObject: Record<string, string> = {};
		for (const typeId of selectedInconsistenciesTypes) {
			inconsistenciesObject[typeId] = exceptionInconsistencyDate || '';
		}

		const body = {
			[idCi]: {
				exceptions: inconsistenciesObject,
				notes: notes || '',
			},
		};

		return this.http.post<any>(url, body, { headers: this.headers });
	}
}
